import { AemEnergyLabelRenditions } from "@omni/types/components/product/energyLabel/energyLabel.type";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { Config } from "@/utils/config.utils";

type EnergyLabelContextValue = {
    labelNested: string;
} & (
    | {
          eprel: true;
          eprelId: string;
          label: string;
          fiche: string;
      }
    | {
          eprel: false;
          label: AemEnergyLabelRenditions | null;
      }
);

type EnergyLabelContextProviderProps = {
    eprelId: string | null;
    label: AemEnergyLabelRenditions | null;
    labelNested: string | null;
    children: ReactNode;
};

export const EnergyLabelContext = createContext<
    EnergyLabelContextValue | undefined
>(undefined);

export const EnergyLabelContextProvider = ({
    eprelId,
    label,
    labelNested,
    children
}: EnergyLabelContextProviderProps) => {
    if (eprelId) {
        return (
            <EnergyLabelContext
                value={{
                    eprel: true,
                    eprelId: eprelId,
                    labelNested: `https://eprel.ec.europa.eu/api/product/${eprelId}/nested-label`,
                    label: `https://eprel.ec.europa.eu/api/product/${eprelId}/labels?format=SVG`,
                    fiche: `https://eprel.ec.europa.eu/api/product/${eprelId}/fiches?language=${Config.getLanguage().toUpperCase()}`
                }}
            >
                {children}
            </EnergyLabelContext>
        );
    } else if (labelNested) {
        return (
            <EnergyLabelContext
                value={{
                    eprel: false,
                    labelNested: labelNested,
                    label: label
                }}
            >
                {children}
            </EnergyLabelContext>
        );
    } else {
        return null;
    }
};

export const useEnergyLabelContext = () => {
    const context = use<EnergyLabelContextValue | undefined>(
        EnergyLabelContext
    );

    if (!isDefined(context)) {
        throw new Error(`${EnergyLabelContext.displayName} is undefined.`);
    }

    return context;
};
